import { render, staticRenderFns } from "./SelectPageSection.vue?vue&type=template&id=f1d24e26"
import script from "./SelectPageSection.vue?vue&type=script&lang=js"
export * from "./SelectPageSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1d24e26')) {
      api.createRecord('f1d24e26', component.options)
    } else {
      api.reload('f1d24e26', component.options)
    }
    module.hot.accept("./SelectPageSection.vue?vue&type=template&id=f1d24e26", function () {
      api.rerender('f1d24e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/SelectPageSection.vue"
export default component.exports